import { useFloating } from '@/components/common/Floating'
import { type MenuOptionType } from '@/defs/input'
import { cn } from '@/utils/commonUtil'

import styles from '../InputMenu.module.scss'

type Props = {
  options: MenuOptionType[]
}

export const InputMenuList = ({ options }: Props) => {
  const { close } = useFloating()

  return (
    <ul className={styles.container}>
      {options.map(({ isHeading, label }, i) => (
        <li className={cn(styles.item, { isHeading, styles })} key={i} onClick={close}>
          {label}
        </li>
      ))}
    </ul>
  )
}
